import { Component } from '@angular/core';

@Component({
    selector: 'cf-events-past',
    template: `<cf-events-list eventView="past"></cf-events-list>`
})
export class PastComponent {}
